const SCHOOL_TOP_BAR_TEXT = 'Fully Managed School Travel Service - Extraordinary School Trips'
const SCHOOL_TOP_BAR_CTA = 'Start Designing Now!'
const SCHOOL_HERO_TITLE = 'Educational and Extraordinary: Designed by Local Travel Experts, for Students.'
const SCHOOL_HERO_TEXT = `Welcome to our Fully Managed Schools Travel Service by Designer Journeys, a unique offering with exclusive access for students.`
const SCHOOL_HERO_CTA = 'Start Designing Now'
const SCHOOL_HERO_ITEMS = (cdn) => [
    {
        title: `258+ designers`,
        content: `Our Network of Local Designers`,
        icon: `${cdn}/icons/groups_three-white.svg`,
    },
    {
        title: `75 countries`,
        content: `Global Extraordinary Experience Await`,
        icon: `${cdn}/icons/globe.svg`,
    },
    {
        title: `94.07%`,
        content: `Satisfaction Rating`,
        icon: `${cdn}/icons/satisfied-white.svg`,
    }
]
const SCHOOL_DIFFERENCE_HEADER = 'The Designer Journeys Difference'
const SCHOOL_DIFFERENCE_SUBHEADER = 'Here’s what Designer Journeys has to offer'
const SCHOOL_DIFFERENCE_CONTENT = [
    {
        title: `Fully outsourced “School Trip”<br/> managed service`,
        content: `Enjoy hassle-free planning with our fully managed service. We manage every detail from itinerary planning, logistics to safety. Leave travel to the experts.`,
        src: 'difference-1',
    },
    {
        title: `Total travel solution - 75+<br/> countries`,
        content: `With access to over 75 countries, our total travel solution offers a wealth of options to match any curriculum. Our tailored designs means almost unlimited travel options.`,
        src: 'difference-2',
    },
    {
        title: `Quality designs - by local<br/> travel experts`,
        content: `By working through the design process with in-destination local experts, we unlock extraordinary experiences that enhance student engagement and create memorable, enriching school trips.`,
        src: 'difference-3',
    },
    {
        title: `Chaperone Service - Increased Student/Supervisor Ratios`,
        content: `Our chaperone service enhances safety with a higher student-to-supervisor ratio, providing personalised attention and supervision for peace of mind for both students and teachers.`,
        src: 'difference-4',
    },
    {
        title: `Risk Managed Approach`,
        content: `Our risk-managed approach prioritises safety and compliance throughout your trip with thorough assessments and tailored measures to ensure a secure, worry-free experience for everyone involved.`,
        src: 'difference-5',
    },
    {
        title: `Local Travel Support `,
        content: `Our local travel support teams provide on-the-ground assistance for logistical challenges, ensuring a smooth and enjoyable experience for students and supervisors throughout your trip.`,
        src: 'difference-6',
    },
]

const SCHOOL_BENEFITS_HEADER = `
Benefits of using Designer Journeys to
<br />
Create your School Trip`
const SCHOOL_BENEFITS_SUBHEADER = 'Discover the Advantages of choosing Designer Journeys for your School Trip.'
const SCHOOL_BENEFITS_FIRST_LIST = (cdn) => [
    {
        title: `Unlock extraordinary<br/> experiences`,
        content: `Only experts on the ground can source for your school.`,
        icon: `${cdn}/images/schooltourdetails/gpp_maybe.svg`,
    },
    {
        title: `Designed for your School's<br/> needs`,
        content: `We work with you to access all your trip needs.`,
        icon: `${cdn}/images/schooltourdetails/GraduationCap.svg`,
    },
]
const SCHOOL_BENEFITS_SECOND_LIST = (cdn) => [
    {
        title: `Working directly reduces<br/> costs`,
        content: `With access to local pricing cost saving accessible.`,
        icon: `${cdn}/images/schooltourdetails/request_quote.svg`,
    },
    {
        title: `Global reach provide great<br/> options`,
        content: `With designers in 74+ countries means nearly unlimited travel options.`,
        icon: `${cdn}/images/schooltourdetails/person_play.svg`,
    },
]

const SCHOOL_HIW_HEADER = 'How it works'
const SCHOOL_HIW_SUBHEADER = 'Here’s what Designer Journeys has to offer'
const SCHOOL_HIW_CONTENT = (cdn) => [
    {
        icon: `${cdn}/images/schooltourdetails/Design.svg`,
        title: 'Design',
        content: `Brief designers to deliver options - based on school needs and curriculum.`,
    },
    {
        icon: `${cdn}/images/schooltourdetails/Customise.svg`,
        title: 'Customise and Finalise',
        content: `Review based on brief and refine traveling costs and options and complete final itinerary.`,
    },
    {
        icon: `${cdn}/images/schooltourdetails/Market.svg`,
        title: 'Market Itinerary',
        content: `Prepare marketing material and itineraries.`,
    },
    {
        icon: `${cdn}/images/schooltourdetails/Communication.svg`,
        title: 'Communications Plan',
        content: `Present itinerary at school for parents.`,
    },
    {
        icon: `${cdn}/images/schooltourdetails/Booking.svg`,
        title: 'Confirm Booking',
        content: `Collect payments and details and lock in booking.`,
    },
    {
        icon: `${cdn}/images/schooltourdetails/TravelSp.svg`,
        title: 'Travel Support',
        content: `Concierge support function and reporting.`,
    },
]
const SCHOOL_CONTACT_US_HEADER = 'Contact our dedicated team to create unforgettable travel experiences for your clients.'
const SCHOOL_CONTACT_US_SUBHEADER = 'Contact Us for Personalised Guidance'
const SCHOOL_CONTACT_US_CTA = 'Contact Us'
const SCHOOL_REVIEWS_HEADER = 'See What our Travellers Have to Say'
const SCHOOL_REVIEWS_SUBHEADER = `At Designer Journeys, we know that we all travel differently. That's why you decide where you travel, how you travel and your travel experiences when you design your trip with us.`
const SCHOOL_REVIEWS_NOTE = `More than 861 satisfied customers`
const SCHOOL_REVIEWS_CONTENT = [
    {
        country: 'Australia',
        date: 'May 25, 2023',
        content: `Upon arrival, my personal guide greeted me warmly and showed a deep understanding of both local culture and impeccable style. Designer Journey had curated a tailor-made itinerary that allowed me to connect with local designers and immerse myself in the world of creativity. Throughout the trip, I had the opportunity to meet talented designers and visit their studios, gaining insight into their unique creations. Designer Journey's selection of locations showcased a diverse range of design experiences, from buzzing fashion districts to hidden gems in cozy neighborhoods.`,
        name: 'Sean and Merle R.',
        type: 'Traveller',

    }
]

const SCHOOL_FAQ_HEADER = 'Frequently asked questions'
const SCHOOL_FAQ_SUBHEADER = `Got questions about Designer Journeys' School Trips? We're here and more than happy to assist you!`
const SCHOOL_FAQ_CONTENT = [
    {
        question: 'What is my role in tour creation?',
        answer: `Your role is simple: share your vision! Let us know the type of trip you dream of and we’ll handle the details to create an extraordinary experience for your students. Whether it’s an educational adventure, a cultural exploration or an outdoor excursion, we are here to bring your ideas to life!`,
    },
    {
        question: `How do you manage risk?`,
        answer: `We prioritise safety by aligning our travel programs with your school’s risk framework, ensuring compliance with your specific requirements. Our in-house risk management team assesses each itinerary for compliance with your risk framework and standards. Additionally, we implement various measures to protect schools and parents from financial risks. To further enhance safety, we provide local support teams at your travel destination, ensuring help is available when needed.`
    },
    {
        question: `How do you build the trips?`,
        answer: `At Designer Journeys, we leverage our global network of hand-selected Local Designers — experienced and knowledgeable travel experts -  who specialise in creating unique experiences for schools. Our Local Designers use their local expertise to build custom itineraries and curated travel packages tailored to educational goals.  Each Local Designer undergoes a rigorous selection process to ensure they are reliable, vetted and committed to delivering quality travel experiences for your students every time.`
    },
    {
        question: `What Travel Support do you offer schools?`,
        answer: `We provide comprehensive support for schools, including local support teams that offer on-the-ground assistance during any trip. Our ‘Chaperone Service’ ensures a higher student-to-supervisor ratio for enhanced safety. We also have daily reporting back to Designer Journeys, the teachers and school (if requested) on trip to ensure multiple touch points to maximise the safety and enjoyment for students and staff.`
    }
]
const SCHOOL_FAQ_CONTACT_HEADER = `Still have questions?`
const SCHOOL_FAQ_CONTACT_SUBHEADER = `Can’t find the answer you’ve been looking for? Talk to our friendly support team!`
const SCHOOL_FAQ_CONTACT_CTA = `Contact us`
const SCHOOL_TRIPS_HEADER = 'Extraordinary School Trips - Developed itineraries'
const SCHOOL_CARD_CONTENT = (cdn) => [
    {
        title: `Start-up<br/> Safari`,
        content: `Innovation Tour of Silicon Valley and San Francisco`,
        image: `${cdn}/images/schooltourdetails/trip-1.jpg`,
    },
    {
        title: `UK Sports<br/> ‘Add-on' Tour`,
        content: `Add 7-days Cultural Extension to any Sports Tour`,
        image: `${cdn}/images/schooltourdetails/trip-2.jpg`,
    },
    {
        title: `Vietnam<br/> Homestay`,
        content: `Authentic Cultural Experience in Vietnamese Homestay`,
        image: `${cdn}/images/schooltourdetails/trip-3.jpg`,
    },
    {
        title: `Technology and Innovation Tour of Japan`,
        content: `Explore the Future of Science & Technology from Robotics to Sustainability`,
        image: `${cdn}/images/schooltourdetails/trip-4.jpg`,
    },
    {
        title: `Art & Theatre in<br/> the US`,
        content: `New York and Washington Art and Theatre Showcase`,
        image: `${cdn}/images/schooltourdetails/trip-5.jpg`,
    },
    {
        title: `Music Tour of<br/> Europe`,
        content: `Explore the Best Music Institutions of Europe`,
        image: `${cdn}/images/schooltourdetails/trip-6.jpg`,
    },
    {
        title: `US Space Camp`,
        content: `An ‘Out of this World’ adventure with NASA`,
        image: `${cdn}/images/schooltourdetails/trip-7.jpg`,
    },
    {
        title: `French Language and Culture Tour`,
        content: `An immersive dive into French Language and Culture`,
        image: `${cdn}/images/schooltourdetails/trip-8.jpg`,
    },
]

const SCHOOL_CONTACT_LINK = `https://docs.google.com/forms/d/e/1FAIpQLSc5ElHynWtPlc-dAAiluAyQNDJyO5H152r9SGT3u_S_8B7DDQ/viewform`

export {
    SCHOOL_TOP_BAR_TEXT,
    SCHOOL_TOP_BAR_CTA,
    SCHOOL_HERO_TITLE,
    SCHOOL_HERO_CTA,
    SCHOOL_HERO_TEXT,
    SCHOOL_HERO_ITEMS,
    SCHOOL_DIFFERENCE_HEADER,
    SCHOOL_DIFFERENCE_SUBHEADER,
    SCHOOL_DIFFERENCE_CONTENT,
    SCHOOL_BENEFITS_HEADER,
    SCHOOL_BENEFITS_SUBHEADER,
    SCHOOL_BENEFITS_FIRST_LIST,
    SCHOOL_BENEFITS_SECOND_LIST,
    SCHOOL_HIW_HEADER,
    SCHOOL_HIW_SUBHEADER,
    SCHOOL_HIW_CONTENT,
    SCHOOL_CONTACT_US_HEADER,
    SCHOOL_CONTACT_US_SUBHEADER,
    SCHOOL_CONTACT_US_CTA,
    SCHOOL_REVIEWS_HEADER,
    SCHOOL_REVIEWS_SUBHEADER,
    SCHOOL_REVIEWS_NOTE,
    SCHOOL_REVIEWS_CONTENT,
    SCHOOL_FAQ_HEADER,
    SCHOOL_FAQ_SUBHEADER,
    SCHOOL_FAQ_CONTENT,
    SCHOOL_FAQ_CONTACT_HEADER,
    SCHOOL_FAQ_CONTACT_SUBHEADER,
    SCHOOL_FAQ_CONTACT_CTA,
    SCHOOL_TRIPS_HEADER,
    SCHOOL_CARD_CONTENT,
    SCHOOL_CONTACT_LINK
}
